export const DEFAULT_SEARCH_DEBOUNCE = 500;

export const SKILL_SOURCE_CUSTOM_ONTOLOGY = 'custom-ontology';
